import React from "react";
import { Route, Redirect } from "react-router-dom";

function PublicRoute({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        !rest.state.user ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/codes",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default PublicRoute;
